import type TechnologySignalFilters from "../../../models/technology/TechnologySignalFilters";
import type UISignal from "../../../models/view/UISignal";
import type UISignalDeps from "../../../models/view/UISignalDeps";
import type UISignalFactory from "../UISignalFactory";

import createTechnologyUISignalNameBuilder from "./technologyUISignalNameBuilder";

const technologyUISignalFactory: UISignalFactory<TechnologySignalFilters> = {
    createUISignal(deps: Readonly<UISignalDeps<TechnologySignalFilters>>): Readonly<UISignal<TechnologySignalFilters>> {
        const {
            technologies,
            technologiesDate,
            numberOfAccounts,
            signal,
            template: { alias, description, templateHint, name, signalSubType, timeframeConfig, signalLifecycleState },
        } = deps;

        const nameBuilder = createTechnologyUISignalNameBuilder({ technologies });
        const lastUpdatedDate = technologiesDate ? technologiesDate : new Date();

        return {
            signalLifecycleState,
            ...signal,
            get name() {
                return nameBuilder.buildName(signal);
            },
            get nameSegments() {
                return nameBuilder.buildNameSegments(signal);
            },
            numberOfAccounts,
            signalSubType,
            timeframeConfig,
            template: { alias, description, name, templateHint },
            selectionTooltipLabels: nameBuilder.buildSelectionTooltipLabels(signal),
            lastUpdatedDate: lastUpdatedDate,
        };
    },
};

export default technologyUISignalFactory;
